/* eslint-disable camelcase */
/* global widgetInit */
import { hexToRgb } from '../../utils/color'

const fontsColorPrimary = widgetInit.settings.fonts_color_primary
const {
  color_primary,
  color_widget_background,
  color_widget_background_opacity,
  color_cell_background,
  color_cell_background_opacity,
  color_lines,
  color_lines_opacity,
  fonts_color_button,
  fonts_color_secondary,
  fonts_color_links,
} = widgetInit.settings
export const rgbaWidgetBackground = hexToRgb(color_widget_background, color_widget_background_opacity)
export const rgbaCellBackground = hexToRgb(color_cell_background, color_cell_background_opacity)
export const rgbaLineBackground = hexToRgb(color_lines, color_lines_opacity)

export const eventOverviewWrapper = {
  height: '100%',
  width: '100%',
}

export const viewWrapper = {
  paddingTop: '62px',
  fontFamily: 'inherit',
  outline: 'none',
  backgroundColor: rgbaWidgetBackground,
}

export const imageWrapper = {
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
}

export const imageContent = {
  width: '100%',
  display: 'block',
}

export const overviewTextBox = {
  position: 'absolute',
  bottom: '18px',
  left: '5.42857%',
  color: 'white',
  paddingRight: '5px',
}

export const label = {
  fontWeight: '500',
  fontSize: '18px',
}

export const datetime = {
  fontWeight: '300',
  fontSize: '12px',
}

export const inventoryWrapper = {
  width: '100%',
  fontFamily: 'inherit',
}

export const inventoryListItem = {
  backgroundColor: rgbaCellBackground,
  padding: '12px 24px',
  minHeight: '70px',
}

export const primaryText = {
  fontSize: '18px',
  fontWeight: '500',
  color: fontsColorPrimary,
}

export const secondaryText = {
  fontSize: '16px',
  fontWeight: '500',
  color: fontsColorPrimary,
}

export const tertiaryText = {
  fontSize: '12px',
  fontWeight: '300',
  color: fonts_color_secondary,
}

export const textOverflow = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

export const headerText = {
  height: '16px',
  fontWeight: '300',
  fontSize: '12px',
  color: fonts_color_secondary,
  margin: '1px 0 4px',
  float: 'left',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '506px',
}

export const remainingQuantity = {
  fontSize: '12px',
  fontWeight: '300',
  color: fonts_color_secondary,
  marginTop: '3px',
}

export const continueButton = {
  width: '130px',
  height: '40px',
  borderRadius: '2px',
  backgroundColor: color_primary,
  fontWeight: '300',
  fontSize: '16px',
  letterSpacing: '1px',
  color: fonts_color_button,
  cursor: 'pointer',
  WebkitTouchCallout: 'none' /* iOS Safari */,
  WebkitUserSelect: 'none' /* Chrome/Safari/Opera */,
  KhtmlUserSelect: 'none' /* Konqueror */,
  MozUserSelect: 'none' /* Firefox */,
  MsUserSelect: 'none' /* Internet Explorer/Edge */,
  UserSelect: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
}

export const eventDetailsWrapper = {
  width: '100%',
  padding: '15px 6.13333% 27px 6.13333%',
  display: 'block',
  fontFamily: 'inherit',
  height: '100%',
}

export const bigLeftWrapper = {
  fontSize: '12px',
  lineHeight: '1.5',
  color: fonts_color_secondary,
  display: 'inline-block',
  float: 'left',
  maxWidth: '315px',
  width: '52%',
  paddingRight: '6%',
}

export const bigRightWrapper = {
  fontWeight: '300',
  fontSize: '12px',
  lineHeight: '1.5',
  color: fonts_color_secondary,
  display: 'inline-block',
  float: 'left',
  maxWidth: '315px',
  width: '48%',
}

export const smallWrapper = {
  opacity: '0.7',
  fontSize: '12px',
  lineHeight: '1.5',
  color: fontsColorPrimary,
  display: 'inline-block',
  float: 'left',
  maxWidth: '100%',
}

export const googleMapWrapper = {
  width: '100%',
  height: '240px',
  frameborder: '0',
  border: '0',
}

export const addressBox = {
  listStyleType: 'none',
  padding: '0px',
}

export const aTag = {
  textDecoration: 'none',
  color: fonts_color_links,
}

export const venueDetailsWrapper = {
  marginTop: '12px',
}

export const galleryCover = {
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  background: 'rgba(0, 0, 0, 0.8)',
  bottom: '0',
  zIndex: '101',
  margin: '0 auto',
  maxWidth: '700px',
  overflowY: 'scroll',
}

export const largeImageWrapper = {
  marginTop: '10px',
  position: 'relative',
  height: '0',
  paddingBottom: '100%',
}

export const largeImageBody = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  padding: '0 4.53333%',
}

export const largeImageContent = {
  display: 'block',
  margin: '0 auto',
  width: '100%',
}

export const imgLabel = {
  color: 'white',
  fontSize: '16px',
  padding: 10,
  textAlign: 'center',
}

export const imageStepper = {
  display: 'block',
  margin: '10px auto 0',
  width: '89.33333%',
  height: '39px',
  textAlign: 'center',
  padding: '10px 0',
}

export const imgStepperLeft = {
  float: 'left',
  height: '100%',
  padding: '0 3.2%',
  fontSize: '23px',
  color: 'white',
  marginTop: '-3px',
  cursor: 'pointer',
}

export const imgStepperRight = {
  float: 'right',
  height: '100%',
  padding: '0 3.2%',
  fontSize: '23px',
  color: 'white',
  marginTop: '-3px',
  cursor: 'pointer',
}

export const stepDisplay = {
  fontSize: '15px',
  fontWeight: '500',
  color: 'white',
}

export const imageX = {
  position: 'absolute',
  color: 'white',
  fontSize: '30px',
  top: '0%',
  right: '6%',
  fontWeight: '100',
  textShadow: '0px 0px 2px rgba(70, 70, 70, 1)',
  cursor: 'pointer',
}

export const inventoryItemSeperator = {
  border: `solid 1px ${rgbaLineBackground}`,
  margin: '0',
}

export const noAvailText = {
  fontFamily: 'inherit',
  fontSize: '15px',
  lineHeight: '45px',
  fontStyle: 'italic',
  color: fonts_color_secondary,
}

const start = hexToRgb('#000000', 0)
const finis = hexToRgb('#000000', 0.7)

export const gradient = {
  background: `linear-gradient(${start}, ${finis})`,
  bottom: 0,
  height: '100%',
  position: 'absolute',
  width: '100%',
}

export const galleryIcon = {
  right: '10px',
  color: 'white',
  position: 'absolute',
  top: '10px',
  zIndex: '5',
  height: '28px',
}

export const tableRowHeight = {
  height: '0px',
}

export const hiddenAlert = {
  position: 'absolute',
  top: '-9999px',
  left: '-9999px',
}
